import { Input } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { DateRangePicker, PhoneInput, SelectInput, TextInput } from ".."
import { DATE_TIME_FORMAT } from "../../../constants"
import { dateTimeFunction } from "../../../utils/date"
import DateTime from "../../../utils/dateTime"
import styles from "./index.module.less"

export default function UnitSelect(props) {
  const { t } = useTranslation()
  const {
    label,
    options,
    value,
    placeholder,
    getOptionLabel = option => option.label,
    getOptionValue = option => option.value,
    defaultOption,
    handleChange,
    useInternalState = true,
    componentType,
    disabled,
    loading,
    preventOnChange = true,
    className,
    getValues,
    splitBy = ",",
    selectOptionsList,
    selectMode,
    disableFuture = true,
    disableDaysBefore = 0,
    restrictRange = false,
    maxLength = 100,
    handleSelectOptionChanged,
  } = props
  const [option, setOption] = useState(options.length > 0 ? options[0] : null)

  useEffect(() => {
    defaultOption && setOption(defaultOption)
  }, [defaultOption, options])

  const disableRange = current => {
    const currentDate = dayjs()
    const daysBefore = dayjs().subtract(disableDaysBefore, "days")
    if (current) {
      if (disableDaysBefore && disableFuture) {
        return current > currentDate || current < daysBefore
      } else if (disableDaysBefore) {
        return current < daysBefore
      } else if (disableFuture) {
        return current > currentDate
      }
      return
    }
    return
  }

  const getConvertedDateValue = dates => {
    return `${dateTimeFunction({
      date: DateTime.formatDate(DateTime.getStartOfDay(dates[0]), DATE_TIME_FORMAT),
      apiRequest: true,
      timeZone: true,
    })},${dateTimeFunction({
      date: DateTime.formatDate(DateTime.getEndOfDay(dates[1]), DATE_TIME_FORMAT),
      apiRequest: true,
      timeZone: true,
    })}`
  }

  const getDateValueFromString = value => {
    if (value) {
      return value?.split(splitBy)
    }
    return undefined
  }

  const getSelectedValue = () => {
    let currentSelectType = option
    let selectedOption = value?.[currentSelectType?.key]
    return !!selectedOption ? selectedOption?.split(",") : []
  }

  const getComponent = () => {
    switch (componentType) {
      case "date":
        return (
          <DateRangePicker
            restrictRange={restrictRange}
            onChange={dates => {
              dates && handleChange(option.value, getConvertedDateValue(dates))
            }}
            disabledDate={disableRange}
            value={getDateValueFromString(value?.[option?.value])}
            noDefault
            inputReadOnly
            {...option?.componentProps}
          />
        )
      case "select":
        return (
          <SelectInput
            value={getSelectedValue()}
            className="selectSearch togglesearch"
            style={{
              width: "100%",
            }}
            placeholder={placeholder ? placeholder : t("Search By") + ` ${option?.label}`}
            disabled={disabled}
            mode={selectMode}
            options={selectOptionsList}
            loading={loading}
            allowClear
            onChange={(value, item) => {
              handleChange(option.value, Array.isArray(value) ? value?.join(",") : value)
            }}
          />
        )
      case "phone":
        return (
          <PhoneInput
            placeholder="Select"
            disabled={disabled}
            onChange={phone => {
              getValues({ key: option.value, value: phone })
            }}
            style={{ minWidth: 120 }}
          />
        )
      default:
        return (
          <TextInput
            value={value?.[option?.value]}
            placeholder={placeholder ? placeholder : t("Search By") + ` ${option?.label}`}
            useInternalState={useInternalState}
            disabled={disabled}
            loading={loading}
            maxLength={option?.maxLength || maxLength}
            {...(preventOnChange && {
              ...(useInternalState
                ? {
                    handleBlur(e) {
                      // option.allowInput && option.allowInput(e.target.value) &&
                      handleChange(option.value, e.target.value)
                    },
                  }
                : {
                    handleChange(e) {
                      // option.allowInput && option.allowInput(e.target.value) &&
                      if (getValues) {
                        getValues({ key: option.value, value: e.target.value })
                      } else {
                        handleChange(option.value, e.target.value)
                      }
                    },
                  }),
            })}
            onPressEnter={e => handleChange(option.value, e.target.value, true)}
          />
        )
    }
  }

  return (
    <div className={className}>
      {label && <label style={{ display: "block" }}>{label}</label>}
      <Input.Group style={{ display: "flex" }} className={styles.unitSelectFirst} compact>
        {getComponent()}
        <SelectInput
          placeholder=""
          value={option}
          options={options}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          disabled={disabled}
          onChange={(value, item) => {
            setOption(item)
            handleSelectOptionChanged(value)
            getValues && getValues(prev => ({ ...prev, key: value }))
          }}
          style={{ minWidth: 120 }}
        />
      </Input.Group>
    </div>
  )
}
